"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Label_component_exports = {};
__export(Label_component_exports, {
  Label: () => Label
});
module.exports = __toCommonJS(Label_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_Select = require("../Select.styled");
var _templateObject;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var Label = function Label2(_ref) {
  var refs = _ref.refs, children = _ref.children;
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, {
    "data-testid": "select-testid",
    ref: refs.setReference,
    $_css: [{
      "margin": "2rem",
      "display": "flex",
      "alignItems": "center",
      "borderStyle": "none",
      "backgroundColor": "transparent",
      "fontSize": "1.125rem",
      "lineHeight": "1.75rem",
      "outline": "2px solid transparent",
      "outlineOffset": "2px",
      "&:focus": {
        "outlineStyle": "solid",
        "outlineColor": "#706C5C"
      },
      "@media (min-width: 680px)": {
        "margin": "1rem"
      }
    }, import_Select.textStyle]
  }, /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, null, children));
};
var _StyledDiv = (0, import_styled_components.default)("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledDiv2 = (0, import_styled_components.default)("div").withConfig({
  displayName: "Labelcomponent___StyledDiv2",
  componentId: "sc-1jvcbkp-0"
})({
  "display": "flex",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Label
});
//# sourceMappingURL=Label.component.js.map